// extracted by mini-css-extract-plugin
export default {"container":"j4-z","list":"k4-z"};